import { EStatus, IFileUploadStatus } from '@/models/fileUpload';
import { FC } from 'react';
import { UploadingFile } from './UploadingFile';
import { UploadCompleted } from './UploadCompleted';
import { NoFileSelected } from './NoFileSelected';
import { twMerge } from 'tailwind-merge';

type FileDataSourceProgressBarProps = {
  fileUpload: IFileUploadStatus;
  filename: string;
  className?: string;
};

export const FileDataSourceProgressBar: FC<FileDataSourceProgressBarProps> = ({ fileUpload, filename, className }) => {
  const renderContent = () => {
    switch (fileUpload.status) {
      case EStatus.UPLOADING:
        return <UploadingFile fileUpload={fileUpload} filename={filename} />;
      case EStatus.SUCCESS:
        return <UploadCompleted filename={filename} />;
      case EStatus.NOT_SELECTED:
        return <NoFileSelected />;
      default:
        return null;
    }
  };

  const content = renderContent();

  return <>{content && <div className={twMerge('flex h-fit gap-2 rounded-xl border border-gray-200 bg-gray-50 p-4', className)}>{renderContent()}</div>}</>;
};
